import './assets/OverridingContent.css';const fullscreen = "_fullscreen_1plvl_1", requestingWrapper = "_requestingWrapper_1plvl_6", tsnLogo = "_tsnLogo_1plvl_31", downloadIcon = "_downloadIcon_1plvl_36", videoBox = "_videoBox_1plvl_54", positioned = "_positioned_1plvl_59", styles = {
  fullscreen,
  requestingWrapper,
  tsnLogo,
  downloadIcon,
  videoBox,
  positioned
};
export {
  styles as s
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiT3ZlcnJpZGluZ0NvbnRlbnQubW9kdWxlLUw4ZHRQbXpoLmpzIiwic291cmNlcyI6W10sInNvdXJjZXNDb250ZW50IjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7In0=
